export function InfoCircleIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_332_1500)">
        <path d="M9.00018 12V9M9.00018 6H9.00768M16.5002 9C16.5002 13.1421 13.1423 16.5 9.00018 16.5C4.85805 16.5 1.50018 13.1421 1.50018 9C1.50018 4.85786 4.85805 1.5 9.00018 1.5C13.1423 1.5 16.5002 4.85786 16.5002 9Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_332_1500">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

InfoCircleIcon.displayName = 'InfoCircleIcon';
